import React from "react";
import { GridWrapper } from "../../GridWrapper/GridWrapper";
import { Card } from "../../card";
import { AddLunchPackages } from "./AddLuncPackages";
import { LunchPackagesLists } from "./LunchPackagesLists";

export const LunchPackages = () => {
  return (
    <GridWrapper
      totalColumns={3}
      childrens={[
        {
          component: (
            <Card>
              <AddLunchPackages />
            </Card>
          ),
          gridSpan: 1,
        },
        {
          component: (
            <Card cardTitle="All packages">
              <LunchPackagesLists />
            </Card>
          ),
          gridSpan: 2,
        },
      ]}
    />
  );
};
